import React, { useState, useEffect } from "react"

import { Button, Tab, Tabs, Badge, Offcanvas } from "react-bootstrap"
import { ChevronRight, ArrowLeftCircle } from "react-feather"

import "./OffcanvasDataTransfer.css"

import AnimatedRing from "../../Components/AnimatedRing/AnimatedRing"

const sampleLocationArray = [
  // { locationNumber: 2010030, locationName: "Altoona" },
  // { locationNumber: 2010011, locationName: "Chippewa" },
  // { locationNumber: 2020022, locationName: "Cranberry" },
  // { locationNumber: 2020013, locationName: "EdgeWood" },
  // { locationNumber: 2020011, locationName: "Greentree" },
  // { locationNumber: 2020016, locationName: "Johnstown" },
  // { locationNumber: 2010012, locationName: "Monaca" },
  // { locationNumber: 2020018, locationName: "Morgantown" },
  { locationNumber: 2020012, locationName: "North Hills" },
  // { locationNumber: 2020017, locationName: "Penn Center" },
  // { locationNumber: 2020015, locationName: "Peters Twp" },
  // { locationNumber: 2010013, locationName: "Pittsburgh Mills" },
  { locationNumber: 2020021, locationName: "Robinson" },
  { locationNumber: 2020023, locationName: "State College" },
  { locationNumber: 2020020, locationName: "Trinity Point" },
  // { locationNumber: 2020014, locationName: "West Mifflin" },
]

// prev colors ["#FFB81C", "#78BE20"]

const countLocations = 32
const countUnsuccessful = 4 //faker.datatype.number({ min: 14, max: 72 });
const countSuccessful = countLocations - countUnsuccessful

function OffcanvasDataTransfer(props) {
  const [isLoading, setIsLoading] = useState(true)
  const [showLocationList, setShowLocationList] = useState(false)
  const [activeTab, setActiveTab] = useState("today")

  useEffect(() => {
    if (props.show) {
      console.log("Offcanvas opened - reset things!")
      setIsLoading(true)
      setActiveTab("today")
      setShowLocationList(false)
      setTimeout(() => {
        setIsLoading(false)
      }, 500)
    }
  }, [props.show])

  const handleSelect = (key) => {
    setActiveTab(key)
    console.log("Currently selected tab:", key)
  }

  const handleBack = () => {
    setShowLocationList(false)
  }

  return (
    <>
      <Offcanvas
        show={props?.show}
        onClose={props?.onClose}
        onHide={props?.onClose}
        placement="end"
        className="oc-custom dt"
      >
        <Offcanvas.Header style={{ justifyContent: "normal" }}>
          {/* <Offcanvas.Title>Transmission Status</Offcanvas.Title> */}

          {showLocationList ? (
            <>
              <ArrowLeftCircle
                color={'#004B87'}
                style={{ cursor: "pointer", marginRight: 10 }}
                size={30}
                onClick={handleBack}
              />
              <Offcanvas.Title>Unsuccessful Locations</Offcanvas.Title>
            </>
          ) : (
            <Offcanvas.Title>Transmission Status</Offcanvas.Title>
          )}

          <button className="btn-close" onClick={props.onClose} aria-label="Close">×</button>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            className={`slide-wrapper ${
              showLocationList ? "show-locations" : ""
            }`}
          >
            {/* Main Transmission Panel */}
            <div className="panel panel-summary">
              {isLoading ? (
                <div class="placeholders">
                  <div class="transmit-summary-card">
                    <div className="d-flex flex-row gap-4 w-100 align-items-center">
                      <div class="transmit-tabs-placeholder"></div>
                      <div class="transmit-tabs-placeholder"></div>
                      <div class="transmit-tabs-placeholder"></div>
                    </div>
                    <div class="transmit-subtext"></div>
                    <div class="transmit-circle-placeholder">
                      {/* <div class="transmit-percentage"></div> */}
                    </div>
                    <div class="transmit-subtext"></div>
                    <div className="d-flex flex-row gap-4">
                      <div class="transmit-button-placeholder"></div>
                      <div class="transmit-button-placeholder"></div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <Tabs
                    defaultActiveKey="today"
                    onSelect={handleSelect}
                    className="mx-3"
                  >
                    <Tab
                      eventKey="today"
                      title={
                        <>
                          Today{" "}
                          <Badge pill variant="primary">
                            {countUnsuccessful}
                          </Badge>
                        </>
                      }
                    >
                      <p className="text-center mt-3 mb-4">
                        {countUnsuccessful} locations were unsuccessful, but you
                        can transmit data any time you have changes.
                      </p>
                      <div className="chart-container">
                        <AnimatedRing
                          key="today"
                          successRatio={14 / 16}
                          countSuccessful={14}
                          countLocations={16}
                        />
                      </div>
                    </Tab>
                    <Tab eventKey="yesterday" title="Yesterday">
                      <p className="text-center mt-3 mb-4">
                        All data transmissions were successful, but you can
                        transmit data any time you have changes.
                      </p>
                      <div className="chart-container">
                        <AnimatedRing
                          key="yesterday"
                          successRatio={32 / 32}
                          countSuccessful={32}
                          countLocations={32}
                        />
                      </div>
                    </Tab>
                    <Tab eventKey="week" title="Past 7 Days">
                      <p className="text-center mt-3 mb-4">
                        All data transmissions were successful, but you can
                        transmit data any time you have changes.
                      </p>
                      <div className="chart-container">
                        <AnimatedRing
                          key="seven-days"
                          successRatio={50 / 50}
                          countSuccessful={50}
                          countLocations={50}
                        />
                      </div>
                    </Tab>
                  </Tabs>

                  <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
                    <button
                      type="button"
                      className="btn-modern primary"
                      style={{ width: activeTab === "today" ? "50%" : "100%" }}
                    >
                      Transmit Data
                    </button>
                    {activeTab === "today" && (
                      <button
                        type="button"
                        className="btn-modern primary-outlined"
                        onClick={() => setShowLocationList(true)}
                        style={{ width: "50%" }}
                      >
                        View Locations
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* Slide-in Location Panel */}
            <div className="panel panel-locations">
              <p>Select any location to retransmit data.</p>
              <div className="list-container">
                {sampleLocationArray.map((location) => (
                  <div key={location.locationNumber} className="listContainer">
                    <div className="list-item">
                      <div className="item-container">
                        <div className="avatar">
                          <img src="/img/icon-location-pin.svg" alt="Client" />
                        </div>
                        <div className="title-container">
                          <div className="title">{location.locationName}</div>
                          <div className="subTitle">
                            {location.locationNumber}
                          </div>
                        </div>
                        <Button variant="Hyperlink" className="chevron">
                          <ChevronRight color={"#004b87"} size={20} />
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default OffcanvasDataTransfer
